import React, { useEffect, useRef, useState } from "react"
import ourStoryImage from "../../images/about/OurStory.png"
import useStoryViewportScroll from "../../hooks/useStoryViewportScroll"

function AboutCopy({ children, windowRef, innerRef }) {
  return (
    <div className="about-copy" ref={windowRef}>
      <div className="about-copy__inner" ref={innerRef}>
        {children}
      </div>
    </div>
  )
}

export default function OurStorySection() {
  const ourStoryRef = useRef(null)
  const imgRef = useRef(null)
  const storyEndRef = useRef(null)
  const copyWindowRef = useRef(null)
  const copyInnerRef = useRef(null)
  const [headerTransparent, setHeaderTransparent] = useState(true)

  useStoryViewportScroll({
    imgEl: imgRef,
    endEl: storyEndRef,
    windowEl: copyWindowRef,
    innerEl: copyInnerRef,
    boxHeightMobile: 340,
  })

  useEffect(() => {
    if (typeof window === "undefined") return
    const el = ourStoryRef.current
    if (!el) return
    let ticking = false
    const BUFFER = 8
    const getHeaderHeight = () => {
      const nav = document.querySelector(".navbar")
      return nav ? Math.round(nav.getBoundingClientRect().height) : 64
    }
    const update = () => {
      ticking = false
      const h = getHeaderHeight()
      const top = Math.round(el.getBoundingClientRect().top)
      const shouldBeSolid = top <= h - BUFFER
      const shouldBeTransparent = top > h + BUFFER
      if (shouldBeSolid && headerTransparent) setHeaderTransparent(false)
      else if (shouldBeTransparent && !headerTransparent)
        setHeaderTransparent(true)
    }
    const onScrollOrResize = () => {
      if (!ticking) {
        ticking = true
        requestAnimationFrame(update)
      }
    }
    update()
    window.addEventListener("scroll", onScrollOrResize, { passive: true })
    window.addEventListener("resize", onScrollOrResize)
    return () => {
      window.removeEventListener("scroll", onScrollOrResize)
      window.removeEventListener("resize", onScrollOrResize)
    }
  }, [headerTransparent])

  return (
    <section id="our-story" ref={ourStoryRef}>
      <div className="container px-5 py-6 mt-5 our-story-container">
        <h1 className="has-text-centered is-size-1 is-size-3-mobile has-text-weight-semibold has-text-centered-desktop has-text-purple mb-6">
          Our Story
        </h1>

        <div className="columns is-variable is-6 has-text-purple is-flex-gap-6">
          <div className="column container-subtitle is-6 has-text-weight-medium is-size-4-desktop is-size-5-tablet">
            <p
              className="is-inline-block has-line-height-3"
              style={{
                maxWidth: "32ch",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              inPowered AI is leading the advancement of sell-side AI
              decisioning, enabling advertisers to achieve better results by
              activating intelligence directly within the exchange.
            </p>

            <img
              ref={imgRef}
              className="mt-6 our-story-image"
              src={ourStoryImage}
              alt="InPowered AI story illustration"
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="column is-6-desktop is-size-5-desktop is-size-5-tablet our-story-paragraphs">
            <p>
              After their first company, NetShelter, was acquired by Ziff Davis,
              founders Peyman and Pirouz Nilforoush set out to tackle a
              challenge they knew well: balancing ad effectiveness with user
              experience. That vision became inPowered AI, a platform built for
              performance without compromise.
            </p>
            <p>
              Today, it enables custom bidding algorithms to optimize every
              impression in real time, activated via PMP across display, video,
              and CTV, delivering 50%–300% performance lifts on outcomes like
              CTR, VCR, conversions, and brand lift.
            </p>
            <p>
              As one of the first platforms integrated with Index Exchange’s
              on-exchange AI, inPowered AI is at the forefront of sell-side
              innovation, empowering brands and agencies to make faster, smarter
              decisions.
            </p>
            <p>
              Recognized by the ANA for “Best Use of AI,” named to the Inc5000,
              and honored as finalists in Digiday Tech, OMMA, and The Drum
              Awards, the company is backed by investors including Gokul
              Rajaram, Bill Wise, and Ari Paparo, building the future of
              programmatic: outcome-driven, privacy-friendly, and powered by AI
              where it matters most.
            </p>

            <div ref={storyEndRef} aria-hidden="true" style={{ height: 1 }} />
          </div>
        </div>
      </div>
    </section>
  )
}

export { AboutCopy }
